(function () {
  'use strict';

  function closeReveal(root) {
    root.querySelectorAll('.st-product-reveal.is-open').forEach(function (reveal) {
      reveal.classList.remove('is-open');
      reveal.setAttribute('aria-hidden', 'true');
    });
    root.querySelectorAll('.st-hotspot.is-active').forEach(function (hotspot) {
      hotspot.classList.remove('is-active');
      hotspot.setAttribute('aria-expanded', 'false');
    });
  }

  function playActiveVideo(root) {
    root.querySelectorAll('.st-hero-video').forEach(function (video) {
      var panel = video.closest('.st-hero-panel');
      var playButton = panel ? panel.querySelector('.st-play') : null;

      if (!panel || !panel.classList.contains('is-active')) {
        video.pause();
        if (playButton) playButton.classList.remove('is-visible');
        return;
      }

      video.muted = true;
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      var promise = video.play();
      if (promise && typeof promise.catch === 'function') {
        promise.then(function () {
          if (playButton) playButton.classList.remove('is-visible');
        }).catch(function () {
          if (playButton) playButton.classList.add('is-visible');
        });
      }
    });
  }

  function activateDuo(root, duoKey, moveFocus) {
    if (!duoKey) return;
    closeReveal(root);

    root.querySelectorAll('[data-duo-panel]').forEach(function (panel) {
      var active = panel.dataset.duoPanel === duoKey;
      panel.classList.toggle('is-active', active);
      panel.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    root.querySelectorAll('[data-duo-trigger]').forEach(function (trigger) {
      var active = trigger.dataset.duoTrigger === duoKey;
      trigger.classList.toggle('is-active', active);
      trigger.setAttribute('aria-selected', active ? 'true' : 'false');
      trigger.setAttribute('tabindex', active ? '0' : '-1');
      if (active && moveFocus) trigger.focus({ preventScroll: true });
    });

    root.querySelectorAll('[data-duo-heading]').forEach(function (heading) {
      heading.classList.toggle('is-active', heading.dataset.duoHeading === duoKey);
    });

    root.querySelectorAll('[data-duo-look]').forEach(function (look) {
      var active = look.dataset.duoLook === duoKey;
      look.classList.toggle('is-active', active);
      look.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    playActiveVideo(root);
  }

  function openProduct(root, hotspot) {
    var panel = hotspot.closest('.st-hero-panel');
    var reveal = panel ? panel.querySelector('.st-product-reveal') : null;
    if (!reveal) return;

    var wasActive = hotspot.classList.contains('is-active');
    closeReveal(root);
    if (wasActive) return;

    var image = reveal.querySelector('.st-product-reveal__image');
    var name = reveal.querySelector('.st-product-reveal__name');
    var link = reveal.querySelector('.st-product-reveal__link');

    image.src = hotspot.dataset.productImage || '';
    image.alt = hotspot.dataset.productTitle || '';
    name.textContent = hotspot.dataset.productTitle || '';
    link.href = hotspot.dataset.productUrl || '#';
    hotspot.classList.add('is-active');
    hotspot.setAttribute('aria-expanded', 'true');
    reveal.classList.add('is-open');
    reveal.setAttribute('aria-hidden', 'false');
  }

  function init(root) {
    if (!root || root.dataset.stInitialized === 'true') return;
    root.dataset.stInitialized = 'true';

    root.querySelectorAll('.st-hotspot').forEach(function (hotspot) {
      hotspot.setAttribute('aria-expanded', 'false');
      hotspot.addEventListener('click', function () { openProduct(root, hotspot); });
    });

    root.querySelectorAll('.st-product-reveal__close').forEach(function (button) {
      button.addEventListener('click', function () { closeReveal(root); });
    });

    root.querySelectorAll('[data-duo-trigger]').forEach(function (trigger, index, triggers) {
      trigger.addEventListener('click', function () {
        activateDuo(root, trigger.dataset.duoTrigger, false);
      });
      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        var direction = event.key === 'ArrowRight' ? 1 : -1;
        var next = (index + direction + triggers.length) % triggers.length;
        activateDuo(root, triggers[next].dataset.duoTrigger, true);
      });
    });

    root.querySelectorAll('.st-play').forEach(function (button) {
      button.addEventListener('click', function () {
        var panel = button.closest('.st-hero-panel');
        var video = panel ? panel.querySelector('video') : null;
        if (!video) return;
        video.muted = true;
        video.play().then(function () {
          button.classList.remove('is-visible');
        }).catch(function () {});
      });
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeReveal(root);
    });

    activateDuo(root, root.dataset.initialDuo || 'red', false);
  }

  function initAll(scope) {
    var context = scope || document;
    if (context.matches && context.matches('.st-experience')) init(context);
    context.querySelectorAll('.st-experience').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:block:select', function (event) {
    var block = event.target.closest('[data-block-id]');
    var root = event.target.closest('.st-experience');
    if (!block || !root) return;
    var duoKey = block.dataset.duoPanel || block.dataset.duoTrigger;
    if (duoKey) activateDuo(root, duoKey, false);
  });
})();
